import type { ISerialize } from '@/objects/ISerialize';
import { TrackingContestant } from './TrackingContestant';
import { TrackingDevice } from './TrackingDevice';

export class RaceContestantWithContestantAndDeviceStatus implements ISerialize {
    public ID: number;

    public Contestant: TrackingContestant | null;

    public Device: TrackingDevice | null;

    public DNX: string;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        ID?: number;
        Contestant?: TrackingContestant | null;
        Device?: TrackingDevice | null;
        DNX?: string | null;
    }) {
        this.ID = values.ID ?? 0;

        this.Contestant = values.Contestant ?? null;

        this.Device = values.Device ?? null;

        this.DNX = values.DNX ?? '';
    }

    public serialize(): string {
        return (
            '{' +
            `"ID": ${JSON.stringify(this.ID)}` +
            ',' +
            `"Contestant": ${!this.Contestant ? null : this.Contestant?.serialize()}` +
            ',' +
            `"Device": ${!this.Device ? null : this.Device?.serialize()}` +
            ',' +
            `"DNX": ${JSON.stringify(this.DNX)}` +
            '}'
        );
    }

    /**
     * Creates an instance of RaceContestantWithContestantAndDeviceStatus from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        ID?: number;
        Contestant?: TrackingContestant | null;
        Device?: TrackingDevice | null;
        DNX?: string | null;
    }): RaceContestantWithContestantAndDeviceStatus {
        return new RaceContestantWithContestantAndDeviceStatus(values);
    }

    public static _FromServerJson(json: any): RaceContestantWithContestantAndDeviceStatus {
        return new RaceContestantWithContestantAndDeviceStatus({
            ID: json.ID,
            Contestant: json.Contestant ? TrackingContestant._FromServerJson(json.Contestant) : null,
            Device: json.Device ? TrackingDevice._FromServerJson(json.Device) : null,
            DNX: json.DNX ?? '',
        });
    }

    /**
     * Creates an instance of RaceContestantWithContestantAndDeviceStatus from another instance of RaceContestantWithContestantAndDeviceStatus.
     * @param other The RaceContestantWithContestantAndDeviceStatus you want to clone
     * @returns A cloned RaceContestantWithContestantAndDeviceStatus
     */
    public static FromOther(other: RaceContestantWithContestantAndDeviceStatus): RaceContestantWithContestantAndDeviceStatus {
        return RaceContestantWithContestantAndDeviceStatus._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return RaceContestantWithContestantAndDeviceStatus.FromOther(this);
    }

    static NAME_OF_CLASS = 'RaceContestantWithContestantAndDeviceStatus';
}
